var diamond = "/static/d9da3293dba45e9b.png";

export { diamond as default };
//# sourceMappingURL=diamond.png.js.map
